"use strict";

export function escapeHTML(str) {
  return new Option(str).innerHTML;
};

export function mentionID(data, type, row, meta) {
  const mentionID = data;
  // Numeric HTML entity is for 'flag' symbol
  return `<div style="font-size: 80%">${escapeHTML(mentionID)} <form class="flag_mention" target="hidden_iframe" action="/mention/flag/${escapeHTML(encodeURIComponent(mentionID))}" method="post" onsubmit="flag_Button_${escapeHTML(mentionID)}.disabled = true; return true;"> <button type="submit" name="flag_Button_${escapeHTML(mentionID)}" class="btn btn-outline-danger btn-sm flag-outline">&#9872;</button></form> <iframe name="hidden_iframe" id="hidden_iframe" style="display: none;"></iframe></div>`;
};

export function mentionContext(data, type, row, meta) {
  const mcontext = data;
  // const mcontext = row[1];
  // .substr(0,50).replace(/ /g, '&nbsp;') + data.substr(50);
  // const mcontext = row[1];
  const mlength = mcontext.length;
  let start = 103;
  let end = mlength - 103;
  if (mlength <= 206 || !mcontext.startsWith("...") || !mcontext.endsWith("...")) {
    // This looks like a context that is either at the start or end of a body
    // of text and as such does not have the customary 103 characters before
    // and after it. Apply a heuristic, which is to highlight the longest
    // uppercase part on the assumption that that is the subject of this
    // mention.

    // Find all all-uppercase substrings (really: strings that start and end
    // with uppercase and that have nothing lowercase inbetween):
    const uppers = mcontext.match(/\p{Lu}[^\p{Ll}]*\p{Lu}/gu);
    if (!uppers) {
      // No recognizable uppercase part, so just return without highlighting:
      return `<div style="font-size: 80%; line-height: 1.06;">${escapeHTML(mcontext)}</div>`;
    }
    // Find the longest of them:
    const longest = uppers.reduce(
      ((longest, current) => current.length > longest.length ? current : longest),
      "",
    );
    start = mcontext.indexOf(longest);
    end = start + longest.length;
  }
  return `<div style="font-size: 80%; line-height: 1.06;">${escapeHTML(mcontext.substring(0, start))
    }<span style='color: red;'>${escapeHTML(mcontext.substring(start, end))
    }</span>${escapeHTML(mcontext.substring(end))}</div>`;
};

export function articleTitle(data, type, row, meta) {
  const title = data;
  return `<div style='font-size: 90%; line-height: 1.06'>${escapeHTML(title)}</div>`;
};

export function authorIDtoHTML(str) {
  return `<a href="/philosopher/${escapeHTML(encodeURIComponent(str))}">${escapeHTML(str)}</a>`;
};

export function disambiguationStatus(data, type, row, meta) {
  return `<div style="font-size: 80%">${escapeHTML(data.replaceAll('_', ' '))}</div>`;
};

export function authorsIDs(data, type, row, meta) {
  if (data === null) {
    return " ";
  }
  const AuthorsID = data;
  return AuthorsID.split(";").map(authorIDtoHTML).join(" ");
};

export function articleID(data, type, row, meta) {
  const articleId = data;
  return `<a href="/article/${escapeHTML(encodeURIComponent(articleId.substring(28)))}" target="_blank">edhiphy</a> | <a href="${escapeHTML(articleId)}" target="_blank">jstor</a>`;
};

export function nbsp(html) {
  return `<span style="white-space: nowrap;">${html}</span>`;
};

export function articleIDnbsp(data, type, row, meta) {
  return nbsp(articleID(data, type, row, meta));
};

export function journalID(data, type, row, meta) {
  const journalId = data;
  return `<a href="/journal/${escapeHTML(encodeURIComponent(journalId))}">${escapeHTML(journalId)}</a>`; // add link to jstor?
};
